import {useEffect, useState} from "react";
import View from "./View";

export default function Container({textSet, buttonText, handler, dismiss}) {
  const [popupText, setPopupText] = useState([""]);
  const [btnText, setBtnText] = useState("");

  useEffect(() => {
    if (textSet && textSet.length > 0) {
      setPopupText(textSet);
    }
  }, [textSet]);

  useEffect(() => {
    setBtnText(buttonText);
  }, [buttonText]);

  const onClickHandler = () => {
    switch (handler.type) {
      case "redirect":
        window.location.href = `${window.location.protocol}//${window.location.host}/studio/?mode=play&pid=${handler.url}`;
        break;

      default:
        break;
    }
    dismiss();
  };

  return <View textSet={popupText} btnText={btnText} onClickHandler={onClickHandler} />;
}
